import React from 'react';
import type { LoginStepRegistry } from './login-shell.types';
import { LoginShell } from './login-shell';
import { BiometricLogin } from './biometric-login/biometric-login';
import { BiometricError } from './biometric-error/biometric-error';
import { EmailLogin } from './email-login/email-login';
import { PasswordLogin } from './password-login/password-login';
import { ForgotPassword } from './forgot-password/forgot-password';
import { VerifyResetCode } from './verify-reset-code/verify-reset-code';
import { ResetPassword } from './reset-password/reset-password';
import { Waitlist } from './waitlist/waitlist';
import { WaitlistSent } from './waitlist-sent/waitlist-sent';
import { WaitlistConfirmed } from './waitlist-confirmed/waitlist-confirmed';
import { useVisitorHeartbeat } from '../../hooks/use-visitor-heartbeat';

export const LOGIN_STEPS: LoginStepRegistry = {
  'biometric-login': BiometricLogin,
  'biometric-error': BiometricError,
  'email-login': EmailLogin,
  'password-login': PasswordLogin,
  'forgot-password': ForgotPassword,
  'verify-reset-code': VerifyResetCode,
  'reset-password': ResetPassword,
  'waitlist': Waitlist,
  'waitlist-sent': WaitlistSent,
  'waitlist-confirmed': WaitlistConfirmed,
};

/** Determine initial login step based on biometric state and boot-failure flags. */
export function computeInitialLoginStep(): 'biometric-login' | 'email-login' {
  // Always start on the email-login screen.
  // Biometric login is available via a button on that screen instead.
  // (Original biometric-login screen and logic are kept intact for future use.)

  // Clean up legacy block flag if present
  const blocked = localStorage.getItem('block_biometric_login') === 'true';
  if (blocked) {
    localStorage.removeItem('block_biometric_login');
  }

  return 'email-login';
}

export const LoginShellWrapper: React.FC = () => {
  useVisitorHeartbeat('login');

  const [initialStep] = React.useState(computeInitialLoginStep);

  return (
    <LoginShell initialStep={initialStep} steps={LOGIN_STEPS} syncToUrl={true} urlKey="s" />
  );
};
